<mat-drawer-container autosize class="mat-typography" title=''>

  <mat-drawer #drawerFilters mode="over" position="end" class="drawer">
   <mat-drawer-content>
    <div class="top-panel flex-row">
      <h2 class="font1 bold">Filter advertisers</h2>
      <div class="text-right">
        <lib-button variant="icon" (buttonClick)="drawerFilters.toggle()" icon="close" tooltip="Close"></lib-button>
      </div>
    </div>

    <form (ngSubmit)="onSubmit()" [formGroup]="form" fxLayout="row wrap" fxLayoutAlign="start center">

      <app-multi-labels class="full-width" formControlName="names" name="names" [placeholder]="'Name'"></app-multi-labels>

      <div form-actions class="actions gap-8">
        <lib-button type="submit" variant="raised" color="primary" [disabled]="!form.valid">Search</lib-button>
        <lib-button type="button" variant="stroked" color="primary" (buttonClick)="onReset()">Reset</lib-button>
      </div>
    </form>

   </mat-drawer-content>
  </mat-drawer>
</mat-drawer-container>

